module.exports = __webpack_public_path__ + "static/media/search-icon.aa2df57c.svg";